export default "__VITE_ASSET__Bb0_plEF__"